import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { presentationsCacheKey } from './usePresentations';
import { templatesCacheKey } from './useTemplates';

export const useCreatePresentationFromReport = () => {
  const client = useQueryClient();
  const {
    mutate: createPresentationFromReport,
    isPending: isCreatingPresentationFromReport,
  } = useMutation({
    mutationFn: async (variables: {
      livePresentationId: string;
      onSuccess: (id: string) => void;
      onError?: (error: Error) => void;
    }) => {
      return await BackendService.instance.presentations.createFromReport({
        livePresentationId: variables.livePresentationId,
      });
    },
    onSuccess: (data, arg) => {
      arg.onSuccess(data.id);
      client.invalidateQueries({ queryKey: [templatesCacheKey] });
      client.invalidateQueries({ queryKey: [presentationsCacheKey] });
    },
    onError: (error, arg) => {
      arg.onError?.(error as Error);
    },
  });

  return {
    isCreatingPresentationFromReport,
    createPresentationFromReport,
  };
};
